import CtaFooter from "../ctaFooter/ctaFooter";
import Testimonials from "../testimonials/testimonials";
import AboutUsCard from "./aboutUsCard/aboutUsCard";
import ProjectsHeroCard from "./projectsCard/projectsHeroCard";
import ServicesCard from "./servicesCard/servicesCard";
import Slider from "./slider/slider";

function Home() {
  return (
    <>
      <Slider />

      <ProjectsHeroCard />

      <AboutUsCard />

      <ServicesCard />

      <Testimonials />

      <CtaFooter />
    </>
  );
}

export default Home;

